import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'notifications';
export default {
	// equivalent to laravel's index/list method
    getAll(token) {
      return Axios.get(RESOURCE_NAME);
    },
    markAllAsRead(token) {
        return Axios.get(RESOURCE_NAME + '/mark-all-as-read');
    },
    getAllnotifications(){
      return RESOURCE_NAME + '-datatables';
    }
};
